module.exports = __webpack_public_path__ + "img/00003.1ebe3b8d.webp";